import { useTranslation } from 'react-i18next';
import SweetAlert from 'react-bootstrap-sweetalert';
import { makeStyles } from '@material-ui/styles';
import buttonStyle from 'assets/jss/material-dashboard-pro-react/components/buttonStyle';
import classNames from 'classnames';

const useStyles = makeStyles({
  button: buttonStyle.button,
  danger: buttonStyle.danger,
  success: buttonStyle.success,
});

const SweetAlertConfirmation = ({
  onCancel,
  onConfirm,
  ...sweetAlertProps
}) => {
  const classes = useStyles();

  const { t } = useTranslation();

  return (
    <SweetAlert
      title={t('common.shared.areYouSure')}
      confirmBtnText={t('common.shared.yes')}
      cancelBtnText={t('common.shared.no')}
      warning={true}
      showCancel={true}
      cancelBtnCssClass={classNames(classes.button, classes.danger)}
      confirmBtnCssClass={classNames(classes.button, classes.success)}
      onCancel={onCancel}
      onConfirm={onConfirm}
      {...sweetAlertProps}
    />
  );
};

export default SweetAlertConfirmation;
